import Item from "./Item";
import "./ItemsContainer.css";
import { PRODUCTS, RESOURCES, COMPANY, SUPPORT } from "./Menus";

const ItemsContainer = () => {
  const productsText = PRODUCTS.map((item) => item.name).join(" ");

  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-4 gap-6 sm:px-8 px-5 py-16">
      <Item Links={[{ name: productsText }]} title="KIPPRA" align="left" disableLink={true} className="products-item" />
      <Item Links={RESOURCES} title="External Links" align="left" />
      <Item Links={COMPANY} title="Quick Links" align="left" />
      <Item Links={SUPPORT} title="Contact Info" align="left" />
    </div>
  );
};

export default ItemsContainer;